<template>
<div class="chapter">
<div class="inner_page">
<p class="end-title-a"><span>PRAISE FOR THE WRITING OF NERO BLANC</span></p>
<p class="normal4">“At last puzzle fans have their revenge … super sleuthing and solving for puzzle lovers and mystery fans.” —Charles Preston, puzzle editor, <i>USA Today</i></p>
<p class="normal4">“Addicts of crossword puzzles will relish <i>The Crossword Murder</i>.” —<i>Chicago Sun-Times</i></p>
<p class="normal4">“A puzzle lover’s delight … A touch of suspense, a pinch of romance, and a whole lot of clever word clues … Blanc has concocted a story sure to appeal to crossword addicts and mystery lovers alike. What’s a three-letter word for this book? F-U-N.” —Earlene Fowler on <i>The Crossword Murder</i></p>
<p class="normal4">“Snappy, well-plotted … an homage to Agatha Christie and Ngaio Marsh … The solid plot never strays from its course and features a surprising yet plausible ending.” —<i>Fort Lauderdale Sun-Sentinel</i> on <i>Two Down</i></p>
<p class="normal4">“Another neat whodunit, along with some clever crosswords … Blanc builds the suspense slowly and surely, challenging the reader with a dandy puzzler.” —<i>Publishers Weekly</i> on <i>The Crossword Connection</i></p>
<p class="normal4">“A great investigative team in the tradition of Nick and Nora … Nero Blanc is a master.” —Book Browser</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// endmatter07.vue?34056b24